
const router_modular = [
    {
        path: '/',
        name: 'Home',
        meta: { title: '首页' },
        component: () => import('@/views/HomeView')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        meta: { title: '房小豆隐私政策' },
        component: () => import('@/views/PrivacyView')
    },
    {
        path: '/termService',
        name: 'TermService',
        meta: { title: '房小豆服务条款' },
        component: () => import('@/views/TermService')
    },
    {
        path: '/newUserBenefits',
        name: 'NewUserBenefits',
        meta: { title: '新用户专享' },
        component: () => import('@/views/NewUserBenefits')
    },
    {
        path: '/house/:id',
        name: 'House',
        meta: { title: '房源详情' },
        component: () => import('@/views/HouseView')
    },
    {
        path: '/dynamics/:id',
        name: 'Dynamics',
        meta: { title: '动态详情' },
        component: () => import('@/views/DynamicsView')
    },
    {
        path: '/idleItems/:id',
        name: 'IdleItems',
        meta: { title: '闲置物品详情' },
        component: () => import('@/views/IdleItems')
    }
]
export default router_modular
